import * as React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";

import { Palette, Metrics } from "../../vars";

const propTypes = {
  icon: PropTypes.string,
  pullRight: PropTypes.bool
};

const OverlayToolbarButton: React.SFC<any> = ({
  className,
  children,
  icon,
  // @ts-ignore
  pullRight,
  ...otherProps
}) => (
  <button className={className} {...otherProps}>
    {icon && <i className="md-icon">{icon}</i>}
    {children}
  </button>
);

OverlayToolbarButton.propTypes = propTypes;

export default styled(OverlayToolbarButton)`
  padding: ${Metrics.Padding.OVERLAY_TOOLBAR_BUTTON_Y}px
    ${Metrics.Padding.OVERLAY_TOOLBAR_BUTTON_X}px;
  color: ${Palette.Rebrand.Colours.P1};
  font-size: ${Metrics.FontSizes.OVERLAY_TOOLBAR_BUTTON_TEXT}px;
  line-height: ${Metrics.LineHeights.OVERLAY_TOOLBAR_BUTTON_TEXT}px;
  border: none;
  background: none;

  ${props => (props.pullRight ? "margin-left: auto;" : null)} &.log-out {
    color: ${Palette.Rebrand.Colours.G4};
    font-size: 12px;

    &:hover {
      color: ${Palette.Rebrand.Colours.P1};
    }
  }
`;
